export default __webpack_public_path__ + "static/media/productDetail.02adb8f4.jpg";